<div class="docs">
  <header class="docs__header">
    <h3 class="docs__title">Documentos</h3>
    <div
      class="docs__meta"
      [class.docs__meta--exceeded]="sumFileSize > maxSum"
    >
      <span class="docs__meta-value">
        {{ formatBytes(sumFileSize) }} / {{ formatBytes(maxSum) }}
      </span>
      <span class="docs__meta-warning" *ngIf="sumFileSize > maxSum">
        — Tamaño total excedido
      </span>
    </div>
  </header>

  <div class="docs__search">
    <svg class="docs__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <input
      type="text"
      class="docs__search-input"
      [(ngModel)]="searchTerm"
      placeholder="Buscar documento…"
      aria-label="Buscar documento"
    />
    <button
      type="button"
      class="docs__search-clear"
      *ngIf="searchTerm"
      (click)="searchTerm = ''"
      aria-label="Limpiar búsqueda"
    >×</button>
  </div>

  <section class="docs__section">
    <button
      type="button"
      class="docs__section-header"
      (click)="toggleSection('tramite')"
      [attr.aria-expanded]="effectiveExpanded('tramite')"
    >
      <h4 class="docs__section-title">Documentos del trámite</h4>
      <svg
        class="docs__section-chevron"
        [class.docs__section-chevron--open]="effectiveExpanded('tramite')"
        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <div class="docs__list" *ngIf="effectiveExpanded('tramite')">
      <app-document-slot
        label="DNI Comprador"
        [numero]="0"
        [files]="filesDniComprador"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 0)"
        (fileRemoved)="deleteFile($event, 0)"
      ></app-document-slot>

      <app-document-slot
        label="DNI Vendedor"
        [numero]="1"
        [files]="filesDniVendedor"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 1)"
        (fileRemoved)="deleteFile($event, 1)"
      ></app-document-slot>

      <app-document-slot
        label="Mandato Comprador"
        [numero]="2"
        [files]="fileMandatoComprador"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 2)"
        (fileRemoved)="deleteFile($event, 2)"
      ></app-document-slot>

      <app-document-slot
        label="Mandato Vendedor"
        [numero]="3"
        [files]="fileMandatoVendedor"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 3)"
        (fileRemoved)="deleteFile($event, 3)"
      ></app-document-slot>

      <app-document-slot
        label="CIF Comprador"
        [numero]="4"
        [files]="filesCIFComprador"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 4)"
        (fileRemoved)="deleteFile($event, 4)"
      ></app-document-slot>

      <app-document-slot
        label="CIF Vendedor"
        [numero]="5"
        [files]="filesCIFVendedor"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 5)"
        (fileRemoved)="deleteFile($event, 5)"
      ></app-document-slot>

      <app-document-slot
        label="Poder (Empresa)"
        [numero]="6"
        [files]="filesPoder"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 6)"
        (fileRemoved)="deleteFile($event, 6)"
      ></app-document-slot>

      <app-document-slot
        label="Factura / Contrato Compraventa"
        [numero]="7"
        [files]="fileFactura"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 7)"
        (fileRemoved)="deleteFile($event, 7)"
      ></app-document-slot>

      <app-document-slot
        label="Ficha Técnica"
        [numero]="8"
        [files]="fileFicha"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 8)"
        (fileRemoved)="deleteFile($event, 8)"
      ></app-document-slot>

      <app-document-slot
        label="Permiso de Circulación"
        [numero]="9"
        [files]="filePermiso"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 9)"
        (fileRemoved)="deleteFile($event, 9)"
      ></app-document-slot>

      <app-document-slot
        label="Padrón / Justificante de Domicilio"
        [numero]="10"
        [files]="filesPadron"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 10)"
        (fileRemoved)="deleteFile($event, 10)"
      ></app-document-slot>

      <app-document-slot
        label="576 / NRC"
        [numero]="11"
        [files]="filesNRC"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 11)"
        (fileRemoved)="deleteFile($event, 11)"
      ></app-document-slot>

      <app-document-slot
        label="Documentos 05"
        [numero]="12"
        [files]="file05"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 12)"
        (fileRemoved)="deleteFile($event, 12)"
      ></app-document-slot>

      <app-document-slot
        label="Documentos 06"
        [numero]="13"
        [files]="file06"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 13)"
        (fileRemoved)="deleteFile($event, 13)"
      ></app-document-slot>

      <app-document-slot
        label="Documentos IVA 4%"
        [numero]="14"
        [files]="fileIva4"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 14)"
        (fileRemoved)="deleteFile($event, 14)"
      ></app-document-slot>

      <app-document-slot
        label="Otros Documentos"
        [numero]="15"
        [files]="fileOtros"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 15)"
        (fileRemoved)="deleteFile($event, 15)"
      ></app-document-slot>
    </div>
  </section>

  <section class="docs__section">
    <button
      type="button"
      class="docs__section-header"
      (click)="toggleSection('ayudas')"
      [attr.aria-expanded]="effectiveExpanded('ayudas')"
    >
      <div class="docs__section-titles">
        <h4 class="docs__section-title">Ayudas</h4>
        <p class="docs__section-subtitle">
          Documentos relativos a MOVES y otras ayudas
        </p>
      </div>
      <svg
        class="docs__section-chevron"
        [class.docs__section-chevron--open]="effectiveExpanded('ayudas')"
        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <div class="docs__list" *ngIf="effectiveExpanded('ayudas')">
      <app-document-slot
        label="Certificado de titularidad cuenta corriente"
        [numero]="58"
        [files]="fileTitularidadCta"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 58)"
        (fileRemoved)="deleteFile($event, 58)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de situación censal"
        [numero]="60"
        [files]="fileCenso"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 60)"
        (fileRemoved)="deleteFile($event, 60)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de residencia fiscal"
        [numero]="61"
        [files]="fileResidenciaFiscal"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 61)"
        (fileRemoved)="deleteFile($event, 61)"
      ></app-document-slot>

      <app-document-slot
        label="Licencia Taxi / VTC"
        [numero]="62"
        [files]="fileLicenciaTaxi"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 62)"
        (fileRemoved)="deleteFile($event, 62)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de baja vehículo"
        [numero]="63"
        [files]="fileBaja"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 63)"
        (fileRemoved)="deleteFile($event, 63)"
      ></app-document-slot>

      <app-document-slot
        label="Permiso de circulación vehículo achatarrado"
        [numero]="64"
        [files]="filePcAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 64)"
        (fileRemoved)="deleteFile($event, 64)"
      ></app-document-slot>

      <app-document-slot
        label="Ficha técnica vehículo achatarrado"
        [numero]="65"
        [files]="fileFtAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 65)"
        (fileRemoved)="deleteFile($event, 65)"
      ></app-document-slot>

      <app-document-slot
        label="IVTM vehículo achatarrado"
        [numero]="50"
        [files]="fileIvtmAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 50)"
        (fileRemoved)="deleteFile($event, 50)"
      ></app-document-slot>

      <app-document-slot
        label="Escritura empresa / Certificado de poder"
        [numero]="51"
        [files]="fileEscritura"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 51)"
        (fileRemoved)="deleteFile($event, 51)"
      ></app-document-slot>

      <app-document-slot
        label="Expediente consorcio compensación de seguros"
        [numero]="52"
        [files]="fileExpedienteConsorcio"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 52)"
        (fileRemoved)="deleteFile($event, 52)"
      ></app-document-slot>

      <app-document-slot
        label="Proforma / Pedido"
        [numero]="53"
        [files]="fileProforma"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 53)"
        (fileRemoved)="deleteFile($event, 53)"
      ></app-document-slot>

      <app-document-slot
        label="Justificantes de pago / Entregas a cuenta"
        [numero]="54"
        [files]="fileJustificantePago"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 54)"
        (fileRemoved)="deleteFile($event, 54)"
      ></app-document-slot>

      <app-document-slot
        label="Contrato financiación / Leasing / Renting"
        [numero]="55"
        [files]="fileContratoLeasing"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 55)"
        (fileRemoved)="deleteFile($event, 55)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado ayuda mínimis"
        [numero]="56"
        [files]="fileMinimis"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 56)"
        (fileRemoved)="deleteFile($event, 56)"
      ></app-document-slot>

      <app-document-slot
        label="Expediente ayudas"
        [numero]="57"
        [files]="fileExpedienteAyudas"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 57)"
        (fileRemoved)="deleteFile($event, 57)"
      ></app-document-slot>
    </div>
  </section>

  <div class="docs__actions">
    <button mat-button class="btn-danger" matStepperPrevious>Atrás</button>
    <button
      mat-button
      class="btn-info"
      (click)="guardar()"
      [disabled]="spinnerFirma"
    >
      Guardar
    </button>
  </div>
</div>

<div
  *ngIf="spinnerFirma"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
  <h4 style="margin-top: 200px; color: white">
    Enviando datos al servidor, por favor, espere...
  </h4>
  <div class="spinner-progress" *ngIf="uploadProgress > 0 && uploadProgress < 100">
    {{ uploadProgress }}%
  </div>
</div>
